import {BasePanel} from "../../BasePanel";
import {GiftSubscriptionFlowController} from "../../../../flows/GiftSubscriptionFlowController";

export class GiftSubscriptionPanel extends BasePanel {
    getControllerClass() {
        return GiftSubscriptionFlowController;
    }
}
